import { DELETE, DOWNLOAD_JSON, VIEW_JSON } from 'src/constants/LabelText';

export const AvailableReportTemplateActions = {
    DELETE,
    VIEW_JSON,
    DOWNLOAD_JSON
};
